import ExternalExchange from '@/common/models/misc-api-models/ExternalExchange';
import ErrorHandler from '@/ErrorHandler';
import APIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetQuery } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_ORGANIZATION_EXTERNAL_EXCHANGES_LIST } from '@/org-app/store/modules/referenceData/mutation-types';
import i18n from '@/vueI18n';

export const useExternalExchanges = createGetQuery<ExternalExchange>(
  [queryKeys.externalExchanges],
  () => APIProxy.instance.getOrganizationExternalExchanges(),
  {
    mutation: (data: ExternalExchange[]) => {
      orgAppStore.modules.ReferenceData.mutations[UPDATE_ORGANIZATION_EXTERNAL_EXCHANGES_LIST](
        orgAppStore.modules.ReferenceData.state,
        data,
      );
    },
    onError: (error) => {
      const msg = i18n.global.t('messages.failedToGetExternalExchanges');
      ErrorHandler.showError(msg, error);
    },
  },
);
